export default {
      id: "arrow-circle-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#arrow-circle",
      toString: function () {
        return this.url;
      }
    }